(() => {
  const wishlistKey = 'sokameja-wishlist:v1';

  const readWishlist = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try {
      window.localStorage.setItem(wishlistKey, JSON.stringify(items));
    } catch (_error) {
      // The visual state still works for this page if browser storage is unavailable.
    }
  };

  const updateWishlistButton = (button, selected) => {
    const label = button.querySelector('[data-sokameja-wishlist-label]');
    const icon = button.querySelector('[aria-hidden="true"]');
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    button.classList.toggle('is-selected', selected);
    if (label) label.textContent = selected ? 'Pridėta prie pageidavimų' : 'Pridėti prie pageidavimų';
    if (icon) icon.textContent = selected ? '♥' : '♡';
  };

  const refreshWishlistButtons = () => {
    const selectedHandles = new Set(readWishlist().map((item) => item.handle));
    document.querySelectorAll('[data-sokameja-wishlist]').forEach((button) => {
      updateWishlistButton(button, selectedHandles.has(button.dataset.productHandle));
    });
  };

  document.addEventListener('click', (event) => {
    const quickViewButton = event.target.closest('[data-sokameja-quick-view]');
    if (quickViewButton) {
      const dialog = document.getElementById(quickViewButton.getAttribute('aria-controls'));
      if (dialog?.showModal) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-sokameja-quick-view-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    const wishlistButton = event.target.closest('[data-sokameja-wishlist]');
    if (wishlistButton) {
      const handle = wishlistButton.dataset.productHandle;
      const title = wishlistButton.dataset.productTitle;
      const items = readWishlist();
      const existingIndex = items.findIndex((item) => item.handle === handle);
      if (existingIndex >= 0) items.splice(existingIndex, 1);
      else items.push({ handle, title });
      writeWishlist(items);
      refreshWishlistButtons();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.tagName === 'DIALOG') event.target.close();
  });

  document.addEventListener('DOMContentLoaded', refreshWishlistButtons, { once: true });

  window.SokamejaCards = { refreshWishlistButtons };
})();
